/* unplugin-vue-components disabled */var render, staticRenderFns
import script from "./orientation-item.vue?vue&type=script&lang=js&"
export * from "./orientation-item.vue?vue&type=script&lang=js&"
import style0 from "./orientation-item.vue?vue&type=style&index=0&id=0733bca1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0733bca1",
  null
  
)

export default component.exports